import { setDefaultOptions as setDefaultDateOptions } from 'date-fns';
import { type Locale as DateLocale, de as deDateLocale, enGB as enDateLocale, nl as nlDateLocale } from 'date-fns/locale';
import i18n, { type Resource } from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector/cjs';
import { initReactI18next } from 'react-i18next';

import de from '@/locales/de.json';
import en from '@/locales/en.json';
import nl from '@/locales/nl.json';

const RESOURCES = {
  en: { translation: en },
  de: { translation: de },
  nl: { translation: nl },
} satisfies Resource;

export const LOCALES = Object.keys(RESOURCES) as Array<keyof typeof RESOURCES>;
export type Locale = keyof typeof RESOURCES;
export const DEFAULT_LOCALE = 'en' as const satisfies Locale;

export const isLocale = (value: unknown): value is Locale => typeof value === 'string' && (LOCALES as string[]).includes(value);

export const resolveLocale = (value: unknown): Locale => (isLocale(value) ? value : DEFAULT_LOCALE);

const LOCALE_DATE_LOCALE_MAP = {
  en: enDateLocale,
  de: deDateLocale,
  nl: nlDateLocale,
} satisfies Record<Locale, DateLocale>;

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LOCALE,
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    resources: RESOURCES,
    supportedLngs: LOCALES,
  });

i18n.on('languageChanged', (locale) => setDefaultDateOptions({ locale: LOCALE_DATE_LOCALE_MAP[resolveLocale(locale)] }));

setDefaultDateOptions({ locale: LOCALE_DATE_LOCALE_MAP[resolveLocale(i18n.language)] });

export default i18n;
